class KlaviyoWaitlistModal {
  constructor() {
    this.modal = document.getElementById("klaviyo-modal-subscribe");

    this.dialog = this.modal.querySelector(".klaviyo-modal__dialog");
    this.content = this.modal.querySelector(".klaviyo-modal__content");
    this.form = this.modal.querySelector("[data-klaviyo-form]");
    this.emailInput = this.modal.querySelector('input[type="email"]');
    this.countrySelect = this.modal.querySelector('select[name="country"]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.successMessage = this.modal.querySelector(".klaviyo-modal__success");
    this.intWarn = this.modal.querySelector(".klaviyo-modal__int-warn");
    this.openButtons = document.querySelectorAll(
      '[data-klaviyo-modal="true"] .product-form__submit',
    );
    this.spcInternationalForm = document.querySelector(
      'form[data-testid*="YqBEcu"]',
    );
    this.spcUSForm = document.querySelector('form[data-testid*="VcDUJw"]');
    document.getElementById("klaviyo-modal-disabled-buttons")?.remove();

    this.init();
  }

  init() {
    this.bindOpen();
    this.bindClose();
    this.bindKeyboard();
    this.bindSubmit();
    this.bindCountry();
    this.initFormObserver();
  }

  open() {
    this.modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("klaviyo-modal-open");

    setTimeout(() => {
      this.emailInput?.focus();
    }, 0);
  }

  close() {
    this.modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("klaviyo-modal-open");
  }

  bindOpen() {
    this.openButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const productForm = button.closest("[data-handle][data-product-id]");
        if (productForm) {
          this.modal.dataset.productHandle = productForm.dataset.handle;
          this.modal.dataset.productId = productForm.dataset.productId;
        }

        this.open();
      });
    });
  }

  bindClose() {
    this.modal.addEventListener("click", (e) => {
      if (
        e.target.matches("[data-modal-close]") ||
        !this.dialog.contains(e.target)
      ) {
        this.close();
      }
    });
  }

  bindKeyboard() {
    document.addEventListener("keydown", (e) => {
      if (this.modal.getAttribute("aria-hidden") !== "false") return;
      if (e.key === "Escape") {
        this.close();
      }
    });
  }

  bindSubmit() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();

      const email = this.emailInput.value.trim();
      const currentForm = this.isUnitedStates()
        ? this.spcUSForm
        : this.spcInternationalForm;
      const emailInput =
        currentForm?.elements?.namedItem?.("email") ??
        currentForm?.elements?.["email"];

      console.log({
        email,
        currentForm,
        emailInput
      });

      if (!email || !currentForm || !emailInput) return;

      emailInput.value = email;

      emailInput.dispatchEvent(new Event("input", { bubbles: true }));
      emailInput.dispatchEvent(new Event("change", { bubbles: true }));

      if (typeof currentForm.requestSubmit === "function") {
        currentForm.requestSubmit();
      } else {
        currentForm.submit();
      }

      this.showSuccessState();
    });
  }

  bindCountry() {
    if (!this.countrySelect) return;

    this.countrySelect.addEventListener("change", () => this.toggleWarn());

    fetch("/browsing_context_suggestions.json")
      .then((response) => response.json())
      .then((data) => this.setCountry(data?.detected_values?.country?.name));
  }

  isUnitedStates() {
    const country = this.countrySelect?.value;
    return country === "United States";
  }

  showSuccessState() {
    this.content.classList.add("blocked");

    if (this.submitButton) {
      this.submitButton.textContent = "Subscribed";
      this.submitButton.disabled = true;
    }

    if (this.successMessage) {
      this.successMessage.classList.remove("hidden");
    }
  }

  setCountry(country) {
    for (const option of this.countrySelect.options) {
      if (option.value === country) {
        option.selected = true;
        this.countrySelect.dispatchEvent(new Event("change"));
        break;
      }
    }
  }

  toggleWarn() {
    this.intWarn?.classList.toggle("hidden", this.isUnitedStates());
  };

  initFormObserver() {
    if (this.spcInternationalForm && this.spcUSForm) return;

    const observer = new MutationObserver((mutations, obs) => {
      const intForm = document.querySelector('form[data-testid*="YqBEcu"]');
      const usForm = document.querySelector('form[data-testid*="VcDUJw"]');

      if (intForm) {
        this.spcInternationalForm = intForm;
      }

      if (usForm) {
        this.spcUSForm = usForm;
      }

      if (this.spcInternationalForm && this.spcUSForm) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

/* init */
new KlaviyoWaitlistModal();